import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksService from '../../util/BooksSvc/BooksSvc';
import inventoryReportTemplate from './inventoryReport.template.html';

export default angular
  .module('books.ui.inventoryReport', [csmCommonWeb, booksService])
  .directive('inventoryReport', inventoryReportDirective).name;

/* @ngInject */
function inventoryReportDirective(BooksSvc, BusyScreen) {
  return {
    template: inventoryReportTemplate,
    // accountNumberHide
    // Optional. Hides the account number input field when true.
    scope: { accountNumberHide: '=' },
    link: function ($scope, element, attr) {
      /*---------------------*/
      /* Sets default values */
      /*---------------------*/
      $scope.req = {
        reportFormat: 'PDF',
        accountID: 0,
        revenueAccountID: 'All Accounts'
      };

      /*****************************************************************************
       * filterItems */
      /**
       * Filters the list of category items based on the categoryID that is selected.
       *****************************************************************************/
      $scope.filterItems = function (item) {
        return (
          !$scope.req.categoryID ||
          !item.id ||
          $scope.req.categoryID == item.categoryID
        );
      };

      /*****************************************************************************
       * formatItem */
      /**
       * Returns the corresponding items from the itemsList() to display in the item
       * typeahead.
       * When no match is found will retun "All Items" will dispalyed in the typeahead
       *
       * @param  model  Current model value
       * @return        Corresponding item.
       *****************************************************************************/
      $scope.formatItem = function (model) {
        if ($scope.items)
          for (var i = 0; i < $scope.items.length; i++) {
            if ($scope.items[i].id == model) {
              return $scope.items[i].name;
            }
          }
        return 'All Items';
      };

      /*****************************************************************************
       * formatItemCategories */
      /**
       * Returns the corresponding categories from the organization to display in the
       * item category typeahead.
       * When no match is found will retun "All Item Categories" to be displayed in
       * the tyepahead.
       *
       * @param  model  Current model value
       * @return        Corresponding categories from the organization.
       *****************************************************************************/
      $scope.formatItemCategories = function (model) {
        if ($scope.categories)
          for (var i = 0; i < $scope.categories.length; i++) {
            if ($scope.categories[i].id == model) {
              return $scope.categories[i].name;
            }
          }
        return 'All Categories';
      };

      /*-------------------------------------------*/
      /* Works with the csmValidator to verify the */
      /* date is present and correctly formatted   */
      /*-------------------------------------------*/
      $scope.valDate = {};
      $scope.validateInput = function () {
        return $scope.valDate.validate();
      };

      $scope.checkCategory = function () {
        if (!angular.isNumber($scope.req.categoryID)) $scope.req.categoryID = 0;
      };

      $scope.checkItem = function () {
        if (!angular.isNumber($scope.req.itemID)) $scope.req.itemID = 0;
      };

      /*-------------------*/
      /* Load initial data */
      /*-------------------*/
      BooksSvc.getOrganization().then(function (resp) {
        $scope.org = resp.data;

        BooksSvc.getProductList(null, true, false, false).then(function (resp) {
          $scope.items = [{ id: 0, name: 'All Items' }].concat(resp.data);

          /*--------------------------------------------------*/
          /* Creates a new categories array from the items    */
          /* array to filter the item typeahead based on the  */
          /* category selected in the Item Category typeahead */
          /*--------------------------------------------------*/
          var catIDs = [];
          var categories = [];
          for (var i = 0; i < resp.data.length; i++)
            if (catIDs.indexOf(resp.data[i].categoryID) == -1) {
              catIDs.push(resp.data[i].categoryID);
              categories.push({
                id: resp.data[i].categoryID,
                name: resp.data[i].category
              });
            }
          $scope.categories = [{ id: 0, name: 'All Categories' }].concat(
            categories
          );

          BooksSvc.getAccounts(true, [
            'UNDEPOSITED_FUNDS',
            'UNDEPOSITED_PAYPAL',
            'BANK',
            'CASH'
          ]).then(function (resp) {
            $scope.accounts = [
              {
                accountID: 0,
                accountName: 'All Accounts',
                accountNumber: 'All'
              }
            ].concat(resp.data);
          });
        });
        BusyScreen.setBusy(false);
      });
    }
  };
}
